import { useQuery } from '@tanstack/react-query'
import { getDraftGenerations } from '../api'

export function useDraftGenerations({
  limit = 20,
  lookbackDays = 7,
  mode = 'all',
} = {}) {
  const query = useQuery({
    queryKey: ['draft-generations', { limit, lookbackDays, mode }],
    queryFn: () => getDraftGenerations({ limit, lookbackDays, mode }),
    staleTime: 60 * 1000,
    retry: (failureCount, error) => {
      const status = error?.status || error?.response?.status
      if (status && status >= 400 && status < 500) return false
      return failureCount < 2
    },
  })

  return {
    draftGenerations: query.data?.data || {
      aiCompanion: [],
      visualBuilder: [],
    },
    counts: query.data?.counts || {
      aiCompanion: 0,
      visualBuilder: 0,
    },
    totalCount: query.data?.totalCount || 0,
    lookbackDays: query.data?.lookbackDays || lookbackDays,
    from: query.data?.from || null,
    to: query.data?.to || null,
    loading: query.isLoading,
    fetching: query.isFetching,
    error: query.error?.message || null,
    refetch: query.refetch,
  }
}
